import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import Header from "../../../components/Header";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { useJoyaRedemptionReport } from "./hooks/useJoyaRedemptionReport";

const JoyaRedemptionReport = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();

  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };

  const { data, isLoading } = useJoyaRedemptionReport(requestParams);

  const tableData = useMemo(
    () =>
      data?.reportData?.map((data) => ({
        invoiceDate: data.invoiceDate,
        invoiceNumber: data.invoiceNumber,
        joyaBenefit: data.joyaBenefit,
        arItem: data.arItem,
        quantity: data.quantity,
        saleAmount: data.saleAmount,
        patientName: data.patientName,
      })),
    [data],
  );

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  const tableDataEmpty = !isLoading && !data?.reportData?.length;

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Joya Redemption"
        selectedClinic={selectedClinic}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getJoyaRedemptionReport()}
        requestParams={requestParams}
        clinics={clinics}
        // modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Invoice Date", accessor: "invoiceDate" },
              { data: "Invoice Number", accessor: "invoiceNumber" },
              { data: "Patient Name", accessor: "patientName" },
              { data: "Joya Benefit", accessor: "joyaBenefit" },
              { data: "AR Item", accessor: "arItem" },
              { data: "Quantity", accessor: "quantity" },
              { data: "Sale Amount", accessor: "saleAmount" },
            ]}
            data={tableData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {tableDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default JoyaRedemptionReport;
